import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

/**
 * Loading Component
 */
class Loading extends Component {

  /**
   * Render Loading Component
   *
   * @returns {*}
   */
  render() {
    const { className, color } = this.props;

    return (
      <div className={[styles.Loading, className].join(' ')}>
        <div className={styles.SpinnerHolder}>
          <div className={[styles.Spinner, color ? styles[color] : null ].join(' ')}></div>
        </div>
      </div>
    );
  }
}

Loading.displayName = "Loading";
Loading.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};
Loading.defaultProps = {
  className: null,
  color: null
};

export default Loading;
